<template>
  <div>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
          <div class="headline">Standard Risk Text Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.stdRiskTxtRef }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.stdRiskTxtLn) }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.stdRiskDetLn) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doStdRiskTxtReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <div class="pt-2">
      <v-btn color="primary" @click.native="doNewStdRiskTxt">
        New Standard Risk Text
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </div>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Standard Risk Text? ({{deleteStdRiskTxt}})
    </confirm>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Standard Risk Text Reference', value: 'stdRiskTxtRef' },
        { text: 'Standard Risk Text', value: 'stdRiskTxtLn' },
        { text: 'Standard Risk Details', value: 'stdRiskDetLn' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedStdRiskTxt: undefined,
      deleteStdRiskTxt: ''
    }
  },
  computed: {
    stdRiskTextMenu() {
      return this.$store.state.parameters.stdRisk.text
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('stdRiskTextInit')
      this.loading = true
      const apiURI = this.stdRiskTextMenu.menu.stdRiskTxts
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((stdRiskTxt) => {
              const convertStdRiskTxt = {
                stdRiskTxtRef: stdRiskTxt.stdRiskTxtRef,
                stdRiskTxtLn: stdRiskTxt.stdRiskTxtLn,
                stdRiskDetLn: stdRiskTxt.stdRiskDetLn
              }
              this.items.push(convertStdRiskTxt)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
        this.errorMessage('Invalid API Url')
      }
    },
    doStdRiskTxtReview(data) {
      if (data && data.item) {
        this.$router.push({ name: 'stdRiskTextReview', params: { id: data.item.stdRiskTxtRef } })
      } else {
        this.errorMessage('Invalid Item')
      }
    },
    doNewStdRiskTxt() {
      this.$router.push({ name: 'stdRiskTextReview', params: { id: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedStdRiskTxt = data
        this.deleteStdRiskTxt = data.stdRiskTxtRef + ' - ' + data.stdRiskTxtLn
      }
    },
    async doRemove() {
      const apiURI = this.stdRiskTextMenu.menu.stdRiskTxtDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          stdRiskTxtRef: this.selectedStdRiskTxt.stdRiskTxtRef
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
